/**
 * Returns true for __separator__ variables, which are rendered as section
 * headings in VariableInput rather than as editable input controls.
 */
export const isVariableSeparator = (dataType: string): boolean =>
  dataType === "__separator__";

export interface VariableSection {
  /** Section title; undefined = the leading ungrouped section before any separator */
  title: string | undefined;
  variables: VariableConfig[];
}

/**
 * Split a flat variables array into sections at each __separator__ variable.
 * Variables before the first separator form a leading section (title: undefined).
 * Each separator starts a new section whose title is the separator's title field.
 * Separators themselves are NOT included in the variables arrays.
 */
export const splitVariableSections = (
  variables: VariableConfig[]
): VariableSection[] => {
  const sections: VariableSection[] = [];
  let current: VariableSection = { title: undefined, variables: [] };

  for (const variable of variables) {
    if (isVariableSeparator(variable.dataType)) {
      sections.push(current);
      current = { title: variable.title, variables: [] };
    } else {
      current.variables.push(variable);
    }
  }
  sections.push(current);

  return sections;
};

export const formatNumber = (num?: number) => {
  if (!num) {
    return undefined;
  } else if (num >= 1e8) {
    return (num / 1e6).toFixed(0) + "M";
  } else if (num >= 1e6) {
    return (num / 1e6).toFixed(1) + "M";
  } else if (num >= 1e5) {
    return (num / 1e3).toFixed(0) + "K";
  } else if (num >= 1e3) {
    return (num / 1e3).toFixed(1) + "K";
  } else {
    return "" + num;
  }
};
